/* unplugin-vue-components disabled */import script from "./BuildEnvironmentBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildEnvironmentBadge.vue?vue&type=script&setup=true&lang=js"

import "./BuildEnvironmentBadge.vue?vue&type=style&index=0&id=86ef855a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86ef855a"]])

export default __exports__